import React, { Component } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import LocalStorage from '../../helpers/local-storage';
import messages from './messages';
import css from './index.scss';
import Badge from '../badge/index';
import CourseBadgeAdmin from '../course-badge-admin/course-badge-admin';
import Button from '../button/index';
import Modal from '../modal/index';
import Confirmation from '../confirmation/index';
import { Warning, Forward } from '../../helpers/icon-dictionary';
import PortalCommunication from '../../portal-comms';
import SvgIcon from '../svg-icon/svg-icon';
import AssignCoursesUPF from '../../containers/assign-courses-upf';
import AssignCoursesLegacy from '../../containers/assign-courses-legacy';
import productEnum from '../../helpers/product-enum';
import { DEFAULT_COURSE_ID, ROLLOVER_INFO_MODAL_OPTOUT } from '../../constants';
import InfoModal from './information-modal';

class DefaultCourseMapperAdmin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedUPFYearGroup: -1,
            selectedLegacyYearGroup: -1,
            selectedCourseType: '',
            showConfirmationModal: false,
            defaultCourses: this.props.defaultCourses,
            upfCourses: this.props.upfCourses,
            disableSave: true,
            disableCancel: true,
            disableUPFAssignToGroup: true,
            disableLegacyAssignToGroup: true,
            selectedUPFCourse: { id: DEFAULT_COURSE_ID, name: '' },
            selectedLegacyCourse: { id: -1, name: '' },
            showUPFCourseSelector: false,
            showLegacyCourseSelector: false,
            showInfoModal: false
        };
    }

    getFilteredCourses = (filtered, course) => {
        if (course.isSelected) {
            filtered.push({
                yearGroupEnum: course.yearGroupId,
                courseId: course.newCourseId
            });
        }
        return filtered;
    }

    saveCourses = () => {
        this.setState({ showInfoModal: false });

        const updatedUPFCourses =
        Array.isArray(this.state.upfCourses) && this.state.upfCourses.reduce((filtered, course) => this.getFilteredCourses(filtered, course), []);

        const updatedLegacyCourses =
        this.state.defaultCourses.reduce((filtered, course) => this.getFilteredCourses(filtered, course), []);
        this.props.handleOnSave({
            defaultCourses: updatedLegacyCourses,
            upfCourses: updatedUPFCourses || []
        });
    }

    handleQueueCourses = () => {
        const currentSelection = LocalStorage.getItem(ROLLOVER_INFO_MODAL_OPTOUT);
        if (!currentSelection) {
            this.setState({
                showInfoModal: true
            });
            return;
        }
        this.saveCourses();
    }

    handleOnUPFCourseSelection = (yearGroupId, courseType) => {
        const { showUPFCourseSelector, selectedUPFYearGroup } = this.state;

        this.setState({
            selectedUPFYearGroup: yearGroupId,
            selectedCourseType: courseType,
            showUPFCourseSelector: selectedUPFYearGroup === yearGroupId ? !showUPFCourseSelector : true,
            showLegacyCourseSelector: false
        });
    }

    handleOnLegacyCourseSelection = (yearGroupId, courseType) => {
        const { showLegacyCourseSelector, selectedLegacyYearGroup } = this.state;

        this.setState({
            selectedLegacyYearGroup: yearGroupId,
            selectedCourseType: courseType,
            showUPFCourseSelector: false,
            showLegacyCourseSelector: selectedLegacyYearGroup === yearGroupId ? !showLegacyCourseSelector : true
        });
    }

    getRowClass = (yearGroupId) => {
        const { selectedUPFYearGroup, selectedLegacyYearGroup, selectedCourseType } = this.state;
        if ((yearGroupId === selectedUPFYearGroup && selectedCourseType === 'upf') ||
        (yearGroupId === selectedLegacyYearGroup && selectedCourseType === 'legacy')) {
            return css.courseSelected;
        }
        return css.courseUnselected;
    }

    renderRows = () => {
        let rows;
        const { intl, selectedProduct } = this.props;
        const { selectedUPFYearGroup, showUPFCourseSelector, showLegacyCourseSelector, defaultCourses, upfCourses } = this.state;
        const isMathletics = selectedProduct.id === productEnum.MATHLETICS.id;

        if (defaultCourses) {
            rows = defaultCourses.map((val) => {
                const rowStyle = this.getRowClass(val.yearGroupId, selectedUPFYearGroup);
                const upfCourse = Array.isArray(upfCourses) && upfCourses.find(course => course.yearGroupId === val.yearGroupId);

                return (<div className={isMathletics ? css.row : css.rowShort} key={val.yearGroupId}>
                    <div className={css.yearRow}>
                        <CourseBadgeAdmin
                            background={
                                (showLegacyCourseSelector || showUPFCourseSelector) && val.yearGroupId === selectedUPFYearGroup ? css.yearSelected : css.yearUnselected
                            }>
                            <Badge
                                badgeStyle={`${css.yearGroup} yg${val.yearGroupId}`}
                                content={val.yearGroupName} />
                        </CourseBadgeAdmin>
                    </div>
                    <div className={css.learningModuleRow}>
                        { isMathletics && <div
                            className={`${css.upf}
                            ${showUPFCourseSelector && rowStyle}`}
                            onClick={() => this.handleOnUPFCourseSelection(val.yearGroupId, 'upf')}
                            role="button"
                            tabIndex="-1">
                            <div className={css.forwardButton}><SvgIcon icon={Forward} /></div>{intl.formatMessage(messages.skillQuests)}:
                        </div> }
                        <div
                            className={`${isMathletics ? css.courses : css.coursesShort}
                            ${showLegacyCourseSelector && rowStyle}`}
                            onClick={() => this.handleOnLegacyCourseSelection(val.yearGroupId, 'legacy')}
                            role="button"
                            tabIndex="-1">
                            <div className={css.forwardButton}><SvgIcon icon={Forward} /></div>{intl.formatMessage(messages[isMathletics ? 'coursesActivityMastery' : 'courses'])}:
                        </div>
                    </div>
                    <div className={css.currentCourseRow}>
                        { isMathletics && <div
                            className={`${css.upfDefaultCourse}
                                ${showUPFCourseSelector && rowStyle}`}>
                            {
                                (upfCourse === undefined || (upfCourse && upfCourse.courseName === undefined)) &&
                                intl.formatMessage(messages.noVoluntaryCourseSet)}
                            {
                                upfCourse && ((upfCourse.courseId === DEFAULT_COURSE_ID && upfCourse.courseName === '') ?
                                    intl.formatMessage(messages.optedOut) : upfCourse.courseName)
                            }
                            {
                                upfCourse && upfCourse.isSelected ? ` ${intl.formatMessage(messages.unconfirmed)}` : ''
                            }
                        </div> }
                        <div
                            className={`${isMathletics ? css.defaultCourse : css.defaultCourseShort}
                                ${showLegacyCourseSelector && rowStyle}`}>
                            {val.courseName} {val.isSelected ? intl.formatMessage(messages.unconfirmed) : ''}
                        </div>
                    </div>
                </div>);
            });
        }

        return rows;
    }

    handleOnClose = () => {
        this.setState({ showConfirmationModal: false });
    }

    handleOnConfirm = () => {
        const courses = this.state.defaultCourses.map(course => ({
            ...course,
            isSelected: false,
            newCourseId: DEFAULT_COURSE_ID,
            newCourseName: ''
        }));

        this.setState(
            {
                disableSave: true,
                showConfirmationModal: false,
                selectedUPFYearGroup: -1,
                selectedLegacyYearGroup: -1,
                selectedCourseType: '',
                selectedUPFCourse: {},
                selectedLegacyCourse: {},
                defaultCourses: courses
            });
    }

    handleOnCancel = () => {
        if (!this.state.defaultCourses.find(val => val.isSelected)) {
            PortalCommunication.navigateToLandingScreen('Course admin');
        } else {
            this.setState({ showConfirmationModal: true });
        }
    }

    onUPFCourseSelect = (course, disableAssignToGroup = false) => {
        this.setState({
            selectedUPFCourse: course,
            disableUPFAssignToGroup: disableAssignToGroup
        });
    }

    onLegacyCourseSelect = (course, disableAssignToGroup = false) => {
        this.setState({
            selectedLegacyCourse: course,
            disableLegacyAssignToGroup: disableAssignToGroup
        });
    }

    assignToUPFYearGroup = () => {
        const { upfCourses, selectedUPFYearGroup, selectedUPFCourse } = this.state;
        const isYearExisting = upfCourses.find(course => course.yearGroupId === selectedUPFYearGroup);
        let courses;

        if (!isYearExisting) {
            // In case there is no default course set for the UPF courses, the year group of that UPF course won't exist
            courses = [...upfCourses, {
                courseId: DEFAULT_COURSE_ID,
                isSelected: true,
                newCourseId: selectedUPFCourse.id,
                newCourseName: selectedUPFCourse.name,
                yearGroupId: selectedUPFYearGroup,
                yearGroupName: selectedUPFYearGroup.toString()
            }];
        } else {
            courses = upfCourses.map((course) => {
                if (course.yearGroupId === selectedUPFYearGroup) {
                    return {
                        ...course,
                        isSelected: true,
                        newCourseId: selectedUPFCourse.id,
                        newCourseName: selectedUPFCourse.name
                    };
                }
                return course;
            });
        }

        this.setState({
            disableSave: false,
            disableUPFAssignToGroup: true,
            selectedUPFCourse: { id: DEFAULT_COURSE_ID, name: '' },
            upfCourses: courses
        });
        this.props.deselectCourses();
    }

    assignToLegacyYearGroup = () => {
        const { defaultCourses, selectedLegacyYearGroup, selectedLegacyCourse } = this.state;

        const courses = defaultCourses.map((course) => {
            if (course.yearGroupId === selectedLegacyYearGroup) {
                return {
                    ...course,
                    isSelected: true,
                    newCourseId: selectedLegacyCourse.id,
                    newCourseName: selectedLegacyCourse.name
                };
            }
            return course;
        });

        this.setState({
            disableSave: false,
            disableLegacyAssignToGroup: true,
            selectedLegacyCourse: { id: -1, name: '' },
            defaultCourses: courses
        });
        this.props.deselectCourses();
    }

    render() {
        const { intl, savingDefaultCourses } = this.props;
        const { showConfirmationModal, showInfoModal } = this.state;

        return (
            <div>
                <InfoModal
                    handleOnSave={this.saveCourses}
                    show={showInfoModal} />
                <div className={css.panel}>
                    <div className={css.lhsPanel}>
                        <div className={css.header}>
                            <div className={css.yearColumn}>{intl.formatMessage(messages.year)}</div>
                            <div
                                className={css.learningModule}>{intl.formatMessage(messages.learningModule)}</div>
                            <div
                                className={css.currentCourseColumn}>{intl.formatMessage(messages.defaultCourse)}</div>
                        </div>
                        <div>{this.renderRows()}</div>
                    </div>
                    <div className={this.state.showUPFCourseSelector ? css.showUPFCourseSelector : css.hideUPFCourseSelector}>
                        <AssignCoursesUPF
                            disableAssignToYear={this.state.disableUPFAssignToGroup}
                            forManageDefaultCourses
                            forYear
                            handleOnCourseSelection={this.onUPFCourseSelect}
                            handleOnYearGroupSave={this.assignToUPFYearGroup}
                            selectedCourse={this.state.selectedUPFCourse}
                            showLegacyCourseSelector={this.state.showLegacyCourseSelector}
                            showUPFCourseSelector={this.state.showUPFCourseSelector}
                        /></div>
                    <div className={this.state.showLegacyCourseSelector ? css.showUPFCourseSelector : css.hideUPFCourseSelector}>
                        <AssignCoursesLegacy
                            assignToYearGroup={this.assignToLegacyYearGroup}
                            disableAssignToYear={this.state.disableLegacyAssignToGroup}
                            forYear
                            handleOnCourseSelection={this.onLegacyCourseSelect}
                            selectedCourse={this.state.selectedLegacyCourse}
                            showLegacyCourseSelector={this.state.showLegacyCourseSelector}
                            showUPFCourseSelector={this.state.showUPFCourseSelector}
                        /></div>
                </div>
                <div className={css.settingsFooter}>
                    <Button
                        containerClassName={css.cancelButton}
                        disabled={savingDefaultCourses}
                        handleOnClick={this.handleOnCancel}
                        label={intl.formatMessage(messages.cancel)}
                    />
                    <Button
                        containerClassName={css.queueButton}
                        disabled={savingDefaultCourses || this.state.disableSave}
                        handleOnClick={this.handleQueueCourses}
                        label={intl.formatMessage(messages.queue)}
                    />
                </div>
                <Modal show={showConfirmationModal}>
                    <Confirmation
                        handleOnCancel={this.handleOnClose}
                        handleOnOk={this.handleOnConfirm}
                        icon={Warning}
                        title={intl.formatMessage(messages.unsavedChanges)} />
                </Modal>
            </div>
        );
    }
}

DefaultCourseMapperAdmin.propTypes = {
    intl: intlShape.isRequired,
    defaultCourses: PropTypes.arrayOf(PropTypes.object),
    upfCourses: PropTypes.arrayOf(PropTypes.object),
    savingDefaultCourses: PropTypes.bool,
    handleOnSave: PropTypes.func,
    deselectCourses: PropTypes.func,
    selectedProduct: PropTypes.object
};

export default injectIntl(styleable(css)(DefaultCourseMapperAdmin));



// WEBPACK FOOTER //
// ./app/components/default-course-mapper-admin/index.js